import React from "react";

export default function BioReactionLog({ log }) {
  if (!log?.length)
    return (
      <div className="bg-white/80 border border-pink-100 rounded-xl p-3 text-xs text-gray-500">
        Observations will appear here once you perform the experiment.
      </div>
    );

  return (
    <div className="bg-white/90 border border-pink-200 rounded-xl p-3 text-xs max-h-40 overflow-y-auto space-y-2">
      {log.map((entry, idx) => (
        <div key={idx} className="flex gap-2 text-gray-700">
          <span className="text-pink-500">●</span>
          {entry}
        </div>
      ))}
    </div>
  );
}
